const UnlikelyAILogo = () => (
  <svg
    width="18"
    height="19"
    viewBox="0 0 18 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.2402 2.45465H0V0H1.2402C3.2648 0 5.07073 0.971295 6.20527 2.46558C7.34043 0.971295 9.14572 0 11.1703 0C14.5831 0 17.3756 2.762 17.3769 6.1363V12.2837C17.3774 12.9593 16.8191 13.5114 16.136 13.5114C15.453 13.5114 14.8946 12.9593 14.8946 12.2837V6.13691C14.8946 4.11173 13.2202 2.45465 11.1715 2.45465C9.123 2.45465 7.4473 4.11173 7.4473 6.13691V12.2837C7.44668 12.9593 6.88894 13.5114 6.20589 13.5114C5.52283 13.5114 4.96447 12.9593 4.96447 12.2837V6.13691C4.96447 4.11173 3.28815 2.45465 1.2402 2.45465Z"
      fill="#B11082"
    />
    <path
      d="M16.1367 15.962H17.3769V18.4167H16.1367C14.112 18.4167 12.3061 17.4454 11.1715 15.9511C10.0364 17.4454 8.23109 18.4167 6.20649 18.4167C2.79366 18.4167 0.00123168 15.6547 2.32687e-06 12.2803L5.05523e-07 6.13291C-0.000613261 5.45745 0.557743 4.90529 1.2408 4.90529C1.92385 4.90529 2.48222 5.45745 2.48222 6.13291V12.2798C2.48222 14.305 4.15671 15.962 6.20526 15.962C8.25381 15.962 9.92951 14.305 9.92951 12.2798V6.13291C9.93013 5.45745 10.4879 4.90529 11.1709 4.90529C11.854 4.90529 12.4123 5.45745 12.4123 6.13291V12.2798C12.4123 14.305 14.0886 15.962 16.1367 15.962Z"
      fill="#B11082"
    />
  </svg>
);

interface RegulationsHeaderProps {
  title: string;
}

export const RegulationsHeader = ({ title }: RegulationsHeaderProps) => {
  return (
    <header className="flex flex-row items-center border-b border-gray-200">
      <div className="flex flex-row items-center w-full h-full">
        <div className="flex border-r border-gray-200 px-3 h-full items-center">
          <UnlikelyAILogo />
        </div>
        <div className="flex flex-row flex-1 items-center justify-between px-3">
          <h3 className="text-lg font-semibold mb-0">{title}</h3>
        </div>
      </div>
    </header>
  );
};
